import { render, staticRenderFns } from "./banner-media.vue?vue&type=template&id=61d3c5a3&scoped=true&"
import script from "./banner-media.vue?vue&type=script&lang=js&"
export * from "./banner-media.vue?vue&type=script&lang=js&"
import style0 from "./banner-media.vue?vue&type=style&index=0&id=61d3c5a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3c5a3",
  null
  
)

export default component.exports